/**
 * Calculates distance in meters
 */
export const calculateDistanceForSpeed = ({
    timeInSeconds,
    speedInMetersPerSecond
}) => timeInSeconds * speedInMetersPerSecond;
